import React from 'react';
import { ArcBatteryLifeProps } from './types';

const ArcBatteryLife: React.FC<ArcBatteryLifeProps> = (props) => {
  const { percent, light } = props;

  if (light) {
    const MAX_WIDTH = 20;
    const safePercent = Math.min(Math.max(percent ?? 0, 0), 100);
    const fillWidth = (safePercent / 100) * MAX_WIDTH;


    return (
      <svg width="28" height="12" viewBox="0 0 28 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 0.5H21C22.933 0.5 24.5 2.067 24.5 4V8C24.5 9.933 22.933 11.5 21 11.5H4C2.067 11.5 0.5 9.933 0.5 8V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#979797" />

        <rect x="2" y="2" width={fillWidth} height="8" rx="1" fill="#69BA6D" />

        <path d="M26 3.5V8.5C27.2119 8.07653 28 7.09142 28 6C28 4.90858 27.2119 3.92347 26 3.5Z" fill="#979797"/>
      </svg>
    );
  }

  return (
    <svg width="33" height="20" viewBox="0 0 33 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="6" width={`${percent || 0}%`} height="8" rx="1" fill="#275028" />
      <rect x="5" y="5" width="24" height="10" rx="2" stroke="white" strokeOpacity="0.6" strokeWidth="2" />
      <path d="M30 7H31C31.5523 7 32 7.44772 32 8V12C32 12.5523 31.5523 13 31 13H30V7Z" fill="white" fillOpacity="0.6" />
    </svg>
  );
};

export default ArcBatteryLife;